import type { FC } from 'react'
import React from 'react'

const BlockRenderer: FC = ({ children }) => {
  return <p className="mt-1">{children}</p>
}

export default BlockRenderer
